import { Head } from '@unhead/react';
import clsx from 'clsx';
import { CSSProperties, forwardRef, ReactNode } from 'react';
import styles from './Page.module.scss';

export const DEFAULT_PAGE_MAX_WIDTH = 1440;

interface PageProps {
  className?: string;
  children: ReactNode;
  title?: string;
  style?: CSSProperties;
}

const Page = forwardRef<HTMLDivElement, PageProps>(({ children, title = '', className, ...other }, ref) => (
  <div className={clsx(styles.container, className)} ref={ref} {...other}>
    <Head>
      {title ? (
        <title>
          {title}
          {' | Sibill'}
        </title>
      ) : (
        <title>Sibill</title>
      )}
    </Head>
    {children}
  </div>
));

export default Page;
